// extracted by mini-css-extract-plugin
export default {"container":"ErrorDisplay_container__13Eaw","message":"ErrorDisplay_message__3ZstC"};